import AnimTextMarker from './AnimTextMarker';
import {TweenMax, TimelineLite} from "gsap";

module.exports = function(str) {
	const TL = new TimelineMax();
	const animationAlpha = {autoAlpha: 1};
	const slide_title_marker = new AnimTextMarker('.slide--catch .title.js-textmarker');
	const slide_text_marker = new AnimTextMarker('.slide--catch .text.js-textmarker');
	slide_title_marker.mark();
	slide_text_marker.mark();

	TL
	.to('.js-animate_001', 1, animationAlpha)
	.to('.js-animate_002', .3, {
		autoAlpha: 1,
		width:"100%",
		onStart:function(){
			$(".slide--home").addClass('active');
			}
		}
	)
	.to('.js-animate_003', .1, animationAlpha)
	.to('.js-animate_003 .bg', .3, {
		width:"100%",
		onComplete:function(){
			slide_title_marker.draw();
			setTimeout(function(){
				slide_text_marker.draw();
			},200);
			// slide_title_marker.drawPromise().then(function(res) {
				// slide_text_marker.draw();
			// });
		}
	})
	.to('.js-animate_020', .5, {
		delay:1,
		autoAlpha: 1,
		onComplete:function(){
			if(!$('.home_our_value .text_animation-bounds').hasClass('animated')){
				$('.home_our_value .text_animation-bounds').addClass('active');
			}
		}
	});
}


// WEBPACK FOOTER //
// ./dev/js/scripts/mv.js